import React from "react";

/**
 * Renderiza markdown inline básico de las líneas del CHANGELOG:
 *   **negrita**  → <strong>
 *   `código`     → <code> con estilo
 * Evita mostrar los marcadores crudos (** y backticks) en la UI.
 * Devuelve un array de nodos React listo para insertar en JSX.
 */
export default function renderMarkdownInline(text) {
  if (text == null) return null;
  const str = String(text);
  const parts = str.split(/(\*\*[^*]+\*\*|`[^`]+`)/g);
  return parts.map((part, i) => {
    if (/^\*\*[^*]+\*\*$/.test(part)) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    if (/^`[^`]+`$/.test(part)) {
      return (
        <code
          key={i}
          style={{
            fontFamily: "monospace",
            fontSize: "0.9em",
            padding: "1px 5px",
            borderRadius: 4,
            backgroundColor: "rgba(127,127,127,0.16)",
          }}
        >
          {part.slice(1, -1)}
        </code>
      );
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
}
